<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()" *ngIf="records, general">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ lang.generalData }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
     <table class="table table-striped table-hover table-bordered" >
        <tbody>
          <tr>           
            <td width="30%">{{lang.type}}</td>
            <td>{{ records.timetable_type }}</td>
          </tr>

          <tr>
            <td width="30%">{{lang.description}}</td>
            <td>{{ records.timetable_discrption }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang.renewalNote }}</td>
            <td>{{ records.timetable_renewal_notes }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang.created }}</td>
            <td>{{ records.timetable_added_date1 }} </td>
          </tr>

          <tr>
            <td width="30%">{{ lang.lastactionPerformed }}</td>
            <td>{{ general.last_action }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang.lastDeadline }}</td>
            <td>{{ general.last_deadline }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang.daysleft }}</td>
            <td>{{ general.days_left }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang.nextDeadline }}</td>
            <td>{{ general.next_deadline }}</td>
          </tr>

          <tr>
            <td width="30%">{{ lang.attachments }}</td>
            <td>
              <div  *ngFor="let tlink of records.timetable_link.split(',') let i = index">
                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/deadline_image/{{ tlink }}" target="_blank">{{ tlink }}</a>
              </div>
            </td>
          </tr>

          <tr>
            <td width="30%">{{ lang.referenceEmail }}</td>
            <td>{{ records.send_email }}</td>
          </tr>

        </tbody>
      </table>

  </div>

</form>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
    <ngx-doc-viewer url="https://angular-doc-viewer.firebaseapp.com/assets/file-sample_150kB.pdf" viewer="google" style="width:100%;height:50vh;"></ngx-doc-viewer>
  </div>
</ng-template>